// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-parent .dropdown-menu[data-bs-popper] {
  margin-left: -110px;
}
.dropdown-menu.show {
  border: none;
  box-shadow: 0px 15px 30px -5px rgba(62, 62, 62, 0.1);
}
.dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-menu.show a {
  margin: 10px 0;
  font-size: 14px;
}
.navbar-dashboard {
  color: white !important;
}
.navbar-expand-lg {
  height: 100px;
}
.navbar-parent {
  display: flex !important;
  justify-content: center;
}
.navbar-parent a {
  display: flex;
  align-items: center;
  color: white !important;
  text-decoration: none;
  width: 100px;
}
.navbar-parent a:hover {
  color: #68ad3f;
}
.nav-parent {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.navbar-toggler {
  border: none !important;
}
.navbar-toggler:focus {
  box-shadow: none;
}
.dropdown a {
  color: black !important;
  width: 100%;
}
.dropdown-toggle {
  color: white !important;
}
#offcanvasNavbarDropdown-expand-sm {
  color: white !important;
  text-transform: capitalize !important;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent;
}
.menu {
  padding: 5px 20px 5px 20px;
}
/* <---------------------------- media query for mpbile devices -------------------------------------> */
@media only screen and (min-width: 0px) and (max-width: 560px) {
  .parent-mobile-nav {
    max-width: 70% !important;
    padding: 25px;
  }
  .navbar-parent {
    width: 100%;
  }
  #offcanvasNavbarDropdown-expand-sm {
    color: rgb(121, 121, 121) !important;
  }
  .navbar-parent a {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-decoration: none;
    height: 50px;
    width: 100%;
    color: rgb(15, 15, 15) !important;
  }
  .nav-parent {
    width: 100%;
    padding: 20px 0px 20px 0px;
    display: flex;
    justify-content: space-between;
  }

  .navbar-dashboard {
    color: black !important;
  }
  .dropdown-menu[data-bs-popper] {
    margin-left: -15px;
  }
}

/* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */
@media only screen and (min-width: 561px) and (max-width: 767px) {

  .container, .container-sm {
    max-width: 100% !important;
  }
  .navbar-dashboard {
    color: black !important;
  }
}

/* <---------------------------- media query for ipad devices -------------------------------------> */
@media only screen and (min-width: 760px) and (max-width: 980px) {
  .dropdown-menu.show a {
    font-size: 16px;
  }
}
/* <---------------------------- media query for ipad pro devices -------------------------------------> */
@media only screen and (min-width: 767px) and (max-width: 2000px) {
  .parent-header {
    height: 8vh;
    padding: 0px 36px !important;
  }
}
.navbar-expand-sm .navbar-nav .dropdown-menu {
  position: absolute;
  width: 185px;
}
@media (min-width: 1366px) {
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
    width: 185px;
  }
  .dropdown-menu.show a {
    margin: 10px 0;
    font-size: 14px;
    font-weight: 400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Parent/ParentHeader/ParentHeader.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oDAAoD;AACtD;AACA;EACE,yDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA,wGAAwG;AACxG;EACE;IACE,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,iCAAiC;EACnC;EACA;IACE,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,8HAA8H;AAC9H;;EAEE;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,sGAAsG;AACtG;EACE;IACE,eAAe;EACjB;AACF;AACA,0GAA0G;AAC1G;EACE;IACE,WAAW;IACX,4BAA4B;EAC9B;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".nav-parent .dropdown-menu[data-bs-popper] {\n  margin-left: -110px;\n}\n.dropdown-menu.show {\n  border: none;\n  box-shadow: 0px 15px 30px -5px rgba(62, 62, 62, 0.1);\n}\n.dropdown-toggle::after {\n  background-image: url('../../Assets/selectArrow.png');\n  color: white;\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: '';\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-menu.show a {\n  margin: 10px 0;\n  font-size: 14px;\n}\n.navbar-dashboard {\n  color: white !important;\n}\n.navbar-expand-lg {\n  height: 100px;\n}\n.navbar-parent {\n  display: flex !important;\n  justify-content: center;\n}\n.navbar-parent a {\n  display: flex;\n  align-items: center;\n  color: white !important;\n  text-decoration: none;\n  width: 100px;\n}\n.navbar-parent a:hover {\n  color: #68ad3f;\n}\n.nav-parent {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.navbar-toggler {\n  border: none !important;\n}\n.navbar-toggler:focus {\n  box-shadow: none;\n}\n.dropdown a {\n  color: black !important;\n  width: 100%;\n}\n.dropdown-toggle {\n  color: white !important;\n}\n#offcanvasNavbarDropdown-expand-sm {\n  color: white !important;\n  text-transform: capitalize !important;\n}\n.dropdown-item.active,\n.dropdown-item:active {\n  background-color: transparent;\n}\n.menu {\n  padding: 5px 20px 5px 20px;\n}\n/* <---------------------------- media query for mpbile devices -------------------------------------> */\n@media only screen and (min-width: 0px) and (max-width: 560px) {\n  .parent-mobile-nav {\n    max-width: 70% !important;\n    padding: 25px;\n  }\n  .navbar-parent {\n    width: 100%;\n  }\n  #offcanvasNavbarDropdown-expand-sm {\n    color: rgb(121, 121, 121) !important;\n  }\n  .navbar-parent a {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    text-decoration: none;\n    height: 50px;\n    width: 100%;\n    color: rgb(15, 15, 15) !important;\n  }\n  .nav-parent {\n    width: 100%;\n    padding: 20px 0px 20px 0px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .navbar-dashboard {\n    color: black !important;\n  }\n  .dropdown-menu[data-bs-popper] {\n    margin-left: -15px;\n  }\n}\n\n/* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */\n@media only screen and (min-width: 561px) and (max-width: 767px) {\n\n  .container, .container-sm {\n    max-width: 100% !important;\n  }\n  .navbar-dashboard {\n    color: black !important;\n  }\n}\n\n/* <---------------------------- media query for ipad devices -------------------------------------> */\n@media only screen and (min-width: 760px) and (max-width: 980px) {\n  .dropdown-menu.show a {\n    font-size: 16px;\n  }\n}\n/* <---------------------------- media query for ipad pro devices -------------------------------------> */\n@media only screen and (min-width: 767px) and (max-width: 2000px) {\n  .parent-header {\n    height: 8vh;\n    padding: 0px 36px !important;\n  }\n}\n.navbar-expand-sm .navbar-nav .dropdown-menu {\n  position: absolute;\n  width: 185px;\n}\n@media (min-width: 1366px) {\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n    width: 185px;\n  }\n  .dropdown-menu.show a {\n    margin: 10px 0;\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
